import { Link } from 'react-router-dom';

import OrderRow from 'profile/orderHistory/OrderRow';

const OrderHistory = (props) => {
  const { orders, settings } = props;
  // Dont show if no data
  if (!orders.data) {
    return null;
  }
  const orderArray = Object.keys(orders.data);
  if (orderArray.length === 0) {
    return null;
  }
  const maxRows = 3;
  const totalOrders = orderArray.length;
  const moreNumber = totalOrders > maxRows ? totalOrders - maxRows : null;
  const displayArray = orderArray.slice(0, maxRows);

  return (
    <div className="c7-account__order-history">
      <h3>Order History</h3>
      {displayArray.map((orderId) => {
        const order = orders.data[orderId];
        return <OrderRow key={order.id} order={order} settings={settings} />;
      })}

      {renderMore(moreNumber)}
    </div>
  );
};

const renderMore = (moreNumber) => {
  if (!moreNumber) {
    return null;
  }
  if (moreNumber === 1) {
    return (
      <Link to="/profile/order-history" className="c7-button-small">
        View {moreNumber} more order
      </Link>
    );
  }
  return (
    <Link to="/profile/order-history" className="c7-button-small">
      View {moreNumber} more orders
    </Link>
  );
};

export default OrderHistory;
